import { useIntl } from '@capsicum/common';
import { type PropsWithChildren } from 'react';
import styled from 'styled-components';

type StepperPageProps = PropsWithChildren<{
	subtitle?: string;
	title: string;
}>;

export const StepperPage = ({ children, subtitle, title }: StepperPageProps) => {
	const { $t } = useIntl();

	return (
		<S.Wrapper>
			<S.Header>
				<S.Overline>{$t('auth.registrationTitle')}</S.Overline>
				<S.Title>{title}</S.Title>
				{subtitle && <S.SubTitle>{subtitle}</S.SubTitle>}
			</S.Header>

			<S.Content>{children}</S.Content>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		height: 100%;
		display: flex;
		flex-direction: column;
		padding-top: ${({ theme }) => theme.spacings.xlarge};
		padding-left: ${({ theme }) => theme.spacings.small};
		padding-right: ${({ theme }) => theme.spacings.small};
		padding-bottom: ${({ theme }) => theme.spacings.medium};
	`;

	export const Header = styled.div`
		color: ${({ theme }) => theme.colors.text.main.enabled};
		margin-bottom: ${({ theme }) => theme.spacings.xxlarge};
	`;

	export const Content = styled.div`
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xlarge};
		margin-top: ${({ theme }) => theme.spacings.xxsmall};
	`;

	export const Overline = styled.div`
		${({ theme }) => theme.fonts.text.text1};
	`;

	export const Title = styled.div`
		${({ theme }) => theme.fonts.text.text8};
	`;

	export const SubTitle = styled.div`
		position: absolute;
		${({ theme }) => theme.fonts.text.caption2};
		color: ${({ theme }) => theme.colors.text.main.subtle};
	`;
}
